import Status from "../util/status.js"
import Text from "./text"

/*
* @description content model temperature key, each entry contains label and color
*/
var temperatureKeyModel = [];

var sonificationModel = {};

/*
* @description content model for each layer in SST activity, 'tracingImage' is user generated 
*/
var layerModel = [
    {
        year: "4b_bsb_text_26",
        sstImage: require("../assets/images/bsb/1988.png"),
        sstImageFirstDescription: "4b_bsb_img_04_accessible_1",
        sstImageSecondDescription: "4b_bsb_img_04_accessible_2",
        expertImage: require("../assets/images/bsb/gmri-sst-1988-tracing-18-25.png"),
        tracingImage: "",
    },
    {
        year: "4b_bsb_text_27",
        sstImage: require("../assets/images/bsb/1998.png"),
        sstImageFirstDescription: "4b_bsb_img_06_accessible_1",
        sstImageSecondDescription: "4b_bsb_img_06_accessible_2",
        tracingImage: "",
    },
    {
        year: "4b_bsb_text_28",
        sstImage: require("../assets/images/bsb/2008.png"),
        sstImageFirstDescription: "4b_bsb_img_08_accessible_1",
        sstImageSecondDescription: "4b_bsb_img_08_accessible_2",
        tracingImage: "",
    },
    {
        year: "4b_bsb_text_29",
        sstImage: require("../assets/images/bsb/2018.png"),
        sstImageFirstDescription: "4b_bsb_img_10_accessible_1",
        sstImageSecondDescription: "4b_bsb_img_10_accessible_2",
        tracingImage: "",
    }
]

export default {
    
    /**
     * @returns background image
     */
    getBackground(){
        // return "https://gmri-ccil.s3.amazonaws.com/xdm/prod/media/content/asset/4b_bsb_img_01/gmri-ACTII-map-1100x690.png";

        return require("../assets/images/bsb/gmri-ACTII-map-1100x690.png")
        //TODO - options for both species
    },

    /**
     * @description gets layer object from layderModel
     * @param index of desired layer
     * @returns layer object
     */
    getLayer(index){
        if (index < layerModel.length){
            return layerModel[index];
        }
        return null;
    },

    getLayerSonificationModel(year){
        return sonificationModel[year];
    },

    /**
     * @returns entire layerModel
     */
    getLayerModel(){
        return layerModel;
    },
    
    /**
     * @returns length of layerModel
     */
    getLayerCount(){
        return layerModel.length;
    },

    /**
     * @description updates layerModel with tracing image
     * @param index of current layer, image to be added to that layer
     */
    updateTracingImage(index, image){
        if (index < layerModel.length){
            layerModel[index].tracingImage = image;
        }
    },

    /**
     * @description resets all the tracing images in layerModel so SST can be restarted
     */
    resetTracingLayers(){
        for (var i = 0; i < layerModel.length; i++){
            layerModel[i].tracingImage = "";
        }
    },

    /**
     * @returns min temperature range of species
     */
    getTemperatureKeyModel(){
        return temperatureKeyModel;
    },


    /**
     * @returns min temperature range of species
     */
    getTemperatureMin(){
        return Number(Text.get("4b_bsb_text_31"));
        //TODO - options for both species
    },

    /**
     * @returns max temperature range of species
     */
    getTemperatureMax(){
        return Number(Text.get("4b_bsb_text_32"));
        //TODO - options for both species
    },
    

    /**
     * @description hydrates sst data
     * @param {*} data
     * @returns Status containing success boolean and result
     */
    hydrate(data){
        var status = new Status();
        var model = [];
        

        if (typeof data["range"] !== "object"){
            status.message = "ERROR: sst range array is not an object";
            return status;
        }

        status = this.hydrateTemperatureKey(data["range"]);

        if (typeof data["sonification"] !== "object"){
            status.message = "ERROR: sst sonification array is not an object";
            return status;
        }

        status = this.hydrateSonification(data["sonification"]);

        return status;
    },

    hydrateSonification(data){
        var status = new Status();
        var model = {};

        for (var i = 0; i < data.length; i++){
            var yearData = data[i], status;
            var key;

            if (typeof yearData["year"] !== "string"){
                status.message = "ERROR: sst sonification field 'year' malformatted or missing";
                return status;
            }

            key = yearData["year"];

            if (typeof yearData["temperature_list"] !== "string"){
                status.message = "ERROR: sst sonification field 'temperature_list' malformatted or missing";
                return status;
            }

            var temps = yearData["temperature_list"].split(",");
            var points = [];

            for (var j = 0; j < temps.length; j++){
                points.push({x : j, y : temps[j]})
            }
            
            model[key] = points;
        }

        sonificationModel = model;

        status.success = true;
        status.result = this.model;
        return status;
    },

    /**
     * @description hydrates sst temperature key json data
     * @param {*} data
     * @returns Status containing success boolean and result
     */
    hydrateTemperatureKey(data){
        var status = new Status();
        var model = [];

        for (var i = 0; i < data.length; i++){
            status = this.hydrateRange(data[i], status);

            if (!status.success){
                return status;
            }

            status.result.index = i;

            model.push(status.result);
        }

        temperatureKeyModel = model;

        status.success = true;
        status.result = this.model;
        return status;
    },

    /**
     * @description hydrates entry of sst temperature key json data
     * @param {*} data
     * @returns Status containing success boolean and result
     * 
     */
    hydrateRange(data, status) {
        var model = {};

        if (typeof data !== "object"){
            status.message = "ERROR: sst range entry is not an object";
            return status;
        }

        //required fields
        if (typeof data["temperature"] === "string"){
            model.temperature = data["temperature"];
        }
        else{
            status.message = "ERROR: sst range field 'temperature' malformatted or missing";
            return status;
        }

        if (typeof data["color"] === "string"){
            model.color = data["color"];
        }
        else{
            status.message = "ERROR: sst range field 'color' malformatted or missing";
            return status;
        }

        status.success = true;
        status.result = model;
        return status;
    }
}